import { IHosDisplayPreferences } from "./types";

export function getSplitSleeperEnabled(
    preferences: DeepReadonly<IHosDisplayPreferences> | undefined,
    userId: string | undefined
): boolean {
    const preference = userId ? preferences?.[userId] : undefined;
    return preference?.splitSleeperEnabled ?? true;
}
